import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import { FloatInput, FloatSelect, HeadPage } from "src/componentes";
import TributacaoCfopCadastroCode from "./TributacaoCfopCadastro.Code";
import { useNavigate } from "react-router-dom";

const TributacaoCfopCadastroView = () => {
  const {
    register,
    errors,
    handleSubmit,
    onSubmit,
    loading,
    incluir,
    data,
    menuItens,
  } = TributacaoCfopCadastroCode();
  const navigate = useNavigate();

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar =
    (id: number, tributacaocfopid: number, type: number) => () => {
      navigate(
        `/fiscal/tributacao/cfop/imposto/cadastro?id=${id}&type=${type}&tributacaocfopid=${tributacaocfopid}`
      );
    };

  return (
    <Container>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <HeadPage headText="Cadastro Cfop">
          {menuItens !== undefined &&
            menuItens.map((item) => (
              <Dropdown.Item
                key={item.name}
                onClick={handleClickNavigate(item.route)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!loading ? (
          <Tabs defaultActiveKey={"tabDados"}>
            <Tab eventKey="tabDados" title="Dados">
              <>
                <Row>
                  <Col>
                    <Col xs={12}>
                      <FloatInput
                        registerField={register("cfop")}
                        label="CFOP"
                        errorsMessage={errors.cfop}
                        inputMask="int"
                        maxLength={4}
                        tooltipMessage="Código CFOP com 4 números, duvidas consulte seu contador."
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <FloatSelect
                      label="Tipo Parâmetro"
                      options={[
                        { label: "Selecione" },
                        { value: "0", label: "Todos" },
                        { value: "1", label: "Categoria Id" },
                      ]}
                      register={register("tipoParametro")}
                      errorsMessage={errors.tipoParametro}
                      tooltipMessage="Parametrize impostos, crie gatilhos diferentes para gerar inteligência em sua grade tributária."
                    />
                  </Col>
                  <Col xs={12} sm={6}>
                    <FloatInput
                      registerField={register("parametroValor")}
                      label="Parâmetro Valor"
                      errorsMessage={errors.parametroValor}
                      inputMask="int"
                      maxLength={4}
                      tooltipMessage="Conforme o tipo do parâmetro configurado digite o valor que o parâmetro será aplicado ao gatilho."
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="d-grid mt-3 mb-5">
                    <Button type="submit">Confirmar</Button>
                  </Col>
                </Row>
              </>
            </Tab>
            {!incluir && (
              <Tab eventKey="tabImpostos" title="Impostos">
                {data && data.length > 0 ? (
                  <Table responsive striped hover>
                    <thead>
                      <tr>
                        <th className="col-6">Imposto</th>
                        <th className="col-6">CSOSN/CST</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item) => (
                        <tr
                          key={item.id}
                          onClick={handleClickAlterar(
                            item.id,
                            item.tributacaoCFOPId,
                            item.tipoImposto
                          )}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="col-6">{item.tipoImpostoDescricao}</td>
                          <td className="col-6">{item.cst}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <Form.Text>Sem Dados</Form.Text>
                )}
              </Tab>
            )}
          </Tabs>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};

export default TributacaoCfopCadastroView;
